import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

//Plain div to display while chunk loads, avoids help menu resizing after loading
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
const loadingDiv = () => <div style={{ width: '100%', height: 29 }} />;

export const ExitBranchDeploy = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ExitBranchDeploy" */ './ExitBranchDeploy'))
			.ExitBranchDeploy,
	loading: loadingDiv,
});

export const FeedbackCollectorButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FeedbackCollectorButton" */ './FeedbackCollectorButton'
			)
		).FeedbackCollectorButton,
	loading: loadingDiv,
});

export { BRANCH_VERSION, BUILD_VERSION, exitBranchFn, isBranchDeployFn } from './branchDeplyConsts';

export { HELLO, PUG, LOCAL } from './knownHosts';
